/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { z } from "zod";

export const deleteApiAuthorsIdPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор автора.")
    })

/**
 * @description Автор удален
 */
export const deleteApiAuthorsId200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const deleteApiAuthorsId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const deleteApiAuthorsId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const deleteApiAuthorsId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const deleteApiAuthorsId500Schema = z.lazy(() => badResponseModelSchema)

export const deleteApiAuthorsIdMutationResponseSchema = z.lazy(() => deleteApiAuthorsId200Schema)